import type { FrameworkClass } from '../framework/framework';
import { findFrameworkInitialization } from '../framework/frameworkInitialization';
import { formatGeneratedPythonCall } from './pythonFormattingUtils';
import { writeConstructorKwargInProgramCode, type ConstructorKwargWriteResult } from './pythonSourceScanUtils';

/**
 * Writes a constructor kwarg in program source without touching the Monaco editor.
 * Used for drive-unit port parameters (`motor_port`, `sensor_port`, etc.) so we do not false-match `parentName.port` inside stream keys like `motor.port1.*`.
 *
 * Inserts the kwarg when the constructor omits it (e.g. `intake = HighSpeedMotor()` relying on the framework
 * default). `applied` reports whether the constructor declares the value afterwards; callers that mirror the write
 * elsewhere, such as dashboard stream sync, must not act when it is false.
 */
export function writeConstructorArgInProgramCode(
  code: string,
  lineNumber: number,
  parentName: string,
  parentClass: FrameworkClass | undefined,
  mechanismClass: FrameworkClass,
  parameterName: string,
  newValue: string
): ConstructorKwargWriteResult {
  const initParam = findFrameworkInitialization(parentClass, mechanismClass, parameterName);
  const argName = initParam?.constructor_arg;
  if (!argName || !parentName) return { code, applied: false };

  return writeConstructorKwargInProgramCode(code, parentName, argName, newValue, lineNumber, mechanismClass.name, formatGeneratedPythonCall);
}
